export default class CurrencyUtils {
  static configurations = {
    "default": {
      locale: "sr-RS",
      options: {
        style: 'currency',
        currency: 'RSD',
        minimumFractionDigits: 2
      }
    },
    "RSD": {
      locale: "sr-RS",
      options: {
        style: 'currency',
        currency: 'RSD',
        minimumFractionDigits: 2
      }
    },
  };

  static getCurrencyFormatter(currencySymbol) {
    const currencyConfig = CurrencyUtils.configurations[currencySymbol] ?? CurrencyUtils.configurations['default'];
    return Intl.NumberFormat(
      currencyConfig.locale,
      currencyConfig.options
    );
  }
}
